<h3 mat-dialog-title>{{title}}</h3>

<div mat-dialog-content>
    <form [formGroup]="completeFormGroup">
      <mat-form-field *ngIf="showInputData" class="card-dialog">
        <mat-label>{{data.task.required_input}}</mat-label>
        <textarea  matInput cdkTextareaAutosize formControlName="input_data"></textarea>
      </mat-form-field> 

      <mat-form-field *ngIf="showComment" class="card-dialog">
        <mat-label>{{issuePlaceHolder}}</mat-label>
        <textarea [ngClass]="validForm == true ? 'notValid' : 'Valid'" matInput cdkTextareaAutosize formControlName="comment"></textarea>
      </mat-form-field>

      <mat-form-field *ngIf="showCorrectiveActionTagNo" class="card-dialog">
        <mat-label>Corrective Action</mat-label>
        <textarea  matInput cdkTextareaAutosize formControlName="correctiveAction"></textarea>
      </mat-form-field>

      <mat-form-field *ngIf="showCorrectiveActionTagNo" class="card-dialog">
        <mat-label>Name</mat-label>
        <textarea  matInput cdkTextareaAutosize formControlName="tagno"></textarea>
      </mat-form-field>    
    </form>
    <div *ngIf="showCorrectiveActionTagNo && eamAssetFlag" class="fx-row-end-center">
      <p [ngStyle]="{'color':descriptionCountOver ? 'red':'black'}">{{descriptionCount}} of {{eAMCharacterCount}} allowed charaters</p>
    </div>
</div>


<div mat-dialog-actions class="action-buttons">
  <button mat-raised-button *ngIf="data.type == 2 || data.type == 4 || data.type == 5 || data.type == 6" class="dia-button" (click)="saveData()">Save</button>
  <button mat-raised-button *ngIf="!editMode && !readOnlyuser && data.requireWorkRequest != 1 && data.type != 2 && data.type != 4 && data.type != 5 && data.type != 6 && !(data.requireWorkRequest == 2 && (data.task.type.toLowerCase().includes('si') || data.task.type.toLowerCase().includes('safety inspection')))" class="dia-button"  (click)="saveData()">TPM Update Only</button>
  <button mat-raised-button *ngIf="!readOnlyuser && eamAssetFlag && data.type != 2 && data.type != 4 && data.type != 5 && data.type != 6" class="dia-button" [disabled]="descriptionCountOver" [ngStyle]="{'opacity':descriptionCountOver ? '0.3': '1'}" (click)="createWorkRequest()">Create Work Request</button>
  <button mat-raised-button *ngIf="!readOnlyuser && eamAssetFlag && data.type != 2 && data.type != 4 && data.type != 5 && data.type != 6" class="dia-button"  (click)="viewWorkRequest()">View Open Work Requests/Orders</button>
  <button mat-raised-button class="dia-button" (click)="onNoClick()">Cancel</button>
</div>
<br>
<br>


